import { Injectable } from '@angular/core';
import { Message } from '@shared/models/Message';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages: Message[] = [];
  success = new Subject<string>();
  successMessage: string;
  error = new Subject<string>();  
  errorMessage: string;
  warning = new Subject<string>();
  warningMessage: string;

  normalMessageLength = 5000;
  longMessageLength = 12000;

  constructor(private toastrService: ToastrService) {
    this.success.subscribe((message) => this.successMessage = message);
    this.error.subscribe((message) => this.errorMessage = message);
    this.warning.subscribe((message) => this.warningMessage = message);
    this.success.pipe(
      debounceTime(5000)
    ).subscribe(() => this.successMessage = null);
    this.error.pipe(debounceTime(5000)).subscribe(() => this.errorMessage = null);
    //this.warning.pipe(debounceTime(5000)).subscribe(() => this.warningMessage = null);
  }

  showSuccessMessage(message: string) {
    this.toastrService.success('', message, {
      timeOut: this.normalMessageLength,
      closeButton: true,
      progressBar: true
    });
  }

  showSuccessLongMessage(message: string) {
    this.toastrService.success('', message, {
      timeOut: this.longMessageLength,
      closeButton: true,
      progressBar: true
    });
  }

  showWarningMessage(message: string, close?:boolean) {
    this.toastrService.warning('', message, {
      timeOut: this.normalMessageLength,
      closeButton: true,
      disableTimeOut: close,
      progressBar: true
    });
  }
  
  showWarningLongMessage(message: string) {
    this.toastrService.warning('', message, {
      timeOut: this.longMessageLength,
      closeButton: true,
      progressBar: true
    });
  }

  showErrorMessage(message: string, close?:boolean) {
    this.toastrService.error('', message, {
      timeOut: this.normalMessageLength,
      closeButton: true,
      disableTimeOut: close,
      progressBar: true
    });
  }

  showErrorLongMessage(message: string) {
    this.toastrService.error('', message, {
      timeOut: this.longMessageLength,
      closeButton: true,
      progressBar: true
    });
  }

  clear() {
    this.messages = [];
  }

  close(message: Message) {
    this.messages.splice(this.messages.indexOf(message), 1);
  }

}